// extracted by mini-css-extract-plugin
module.exports = {"toggle":"gUx_eA","checked":"_0IBoAg","label":"_3yZd2A"};